import { Provider } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import { StoreEnvironment } from '../Types/StoreTypes';
import { store } from '../store';

const resolveDemo = () => (store.getState().environment as StoreEnvironment).demoInstance;

export const providerService = {
    getProviders: async (): Promise<{ data: Provider[] }> => {
        const demo = resolveDemo();
        return requestClient.get(`${demo ? '/demo' : ''}/providers/get`);
    },
};
